import { useTranslation } from "react-i18next";
import YouTubeFacade from "@/components/YouTubeFacade";

const VideoTestimonial = () => {
  const { t, i18n } = useTranslation();
  
  const videoUrl = i18n.language === 'es' 
    ? 'https://www.youtube.com/embed/Z6ul_Jf9J6k'
    : 'https://www.youtube.com/embed/gpxaeTJB7cA';

  return (
    <section
      id="video-testimonial"
      className="py-16 sm:py-20 md:py-32 bg-background"
      role="region"
      aria-label="Patient video testimonial"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-3 sm:mb-4 px-2">
            {t('videoTestimonial.title')}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto px-4">
            {t('videoTestimonial.subtitle')}
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border bg-muted group">
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <YouTubeFacade
                videoUrl={videoUrl}
                title="Patient Testimonial Video - LS Dental Costa Rica"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoTestimonial;
